import { useBlocker } from "react-router-dom";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AppConfig from "util/AppConfig";
const locationHasChanged = (currentLocation, newLocation, question, ignoredRoutes) => newLocation.pathname !== currentLocation.pathname && !ignoredRoutes.includes(newLocation.pathname) ? (
  // eslint-disable-next-line no-alert
  !window.confirm(question)
) : false;
const ConfirmLeaveDialog = ({ question: questionProp = void 0, ignoredRoutes = [] }) => {
  const { t } = useTranslation("common");
  const question = questionProp != null ? questionProp : t("confirm_leave.question");
  const handleLeavePage = useCallback(
    (e) => {
      if (AppConfig.gl2DevMode()) {
        return null;
      }
      e.returnValue = question;
      return question;
    },
    [question]
  );
  useEffect(() => {
    window.addEventListener("beforeunload", handleLeavePage);
    return () => {
      window.removeEventListener("beforeunload", handleLeavePage);
    };
  }, [handleLeavePage]);
  useBlocker(
    (history) => !AppConfig.gl2DevMode() && locationHasChanged(history.currentLocation, history.nextLocation, question, ignoredRoutes)
  );
  return null;
};
export default ConfirmLeaveDialog;
